<template>
    <v-container fluid class="pb-0">
        <v-row no-gutters cols="12" class="pb-2">
            <v-col cols="2">
                <v-btn-primary block @click="editPartitionTag()" data-cy="PartitionTags-add">
                    Ajouter
                </v-btn-primary>
            </v-col>
            <v-col class="pl-2">
                <v-text-field
                    v-model="search"
                    append-inner-icon="$search"
                    label="Recherche"
                    outlined
                    hide-details
                    clearable
                    @click:clear="search = ''"
                    density="compact"
                />
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-combobox
                    v-model="filterCompany"
                    :items="allAvailableCompanies"
                    label="Société"
                    item-title="key"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                >
                </v-combobox>
            </v-col>
        </v-row>
        <RuleTable
            :rule="'partitionTag'"
            :items="sortedPartitionTags"
            :hideDuplication="true"
            :accountingCompanyId="companyId"
            :hideIntersection="true"
            :maxHeight="maxHeightRT"
            @to-route="editPartitionTag($event)"
            @delete="
                selectedPartitionTag = $event;
                dialogDisconnectPartitionTag = true;
            "
        ></RuleTable>
        <!-- <oss-dialog
            v-model="dialogCreatePartitionTag"
            v-if="dialogCreatePartitionTag"
            :title="'Créer une partition générique'"
            width="1000px"
            :actions="actions"
        >
            <template v-slot:content>
                <PartitionTag
                    :actions="actions"
                    :accountingFirmId="accountingFirmId"
                    @accountingWorkspaceCreated="refreshPartitionTags"
                >
                </PartitionTag>
            </template>
</oss-dialog> -->

        <oss-dialog
            v-model="dialogDisconnectPartitionTag"
            v-if="dialogDisconnectPartitionTag"
            :max-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Supprimer la partition générique"
            valid-title="Retirer"
            @valid="deletePartitionTag(selectedPartitionTag)"
        >
            <v-row class="mx-2">
                <v-col>
                    Vous êtes sur le point de supprimer la partition générique
                    <b>{{ selectedPartitionTag.name }}</b
                    >. Confirmer la suppression ?
                </v-col>
            </v-row>
        </oss-dialog>

        <!-- <oss-dialog
            v-model="dialogEditPartitionTag"
            v-if="dialogEditPartitionTag"
            title="Edition de l'espace de travail"
            width="1000px"
            :actions="actions"
        >
            <template v-slot:content>
                <PartitionTag
                    :actions="actions"
                    :accountingFirmId="accountingFirmId"
                    :existingPartitionTag="selectedPartitionTag"
                    @accountingWorkspaceUpdated="refreshPartitionTags"
                >
                </PartitionTag>
            </template>
        </oss-dialog> -->
    </v-container>
</template>

<script lang="ts">
import _ from "lodash";
import { User } from "../../store/store";
import { Apollo } from "@/decorators";
// import PartitionTag from '../admin/PartitionTag.vue'
import RuleTable from "../admin/RuleTable.vue";
import { DialogAction } from "../../services/dialogAction";
import { documentLogs } from "../../services/accountingItemServices";
// import DELETE_ACCOUNTING_WORKSPACE from "../../graphql/partitionTag/DeletePartitionTag.gql"
import PARTITION_TAGS_ACCOUNTING_FIRM from "../../graphql/tag/PartitionTagsAccountingFirm.gql";
import PARTITION_TAGS_SCOPING from "../../graphql/tag/PartitionTagsScoping.gql";
import UPDATE_TAG from "../../graphql/tag/UpdateTag.gql";
import DELETE_PARTITION from "../../graphql/tag/DeletePartitionTag.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

// const env = getEnv()

// const BobbeeImg = require("../../assets/img/bobbee3d/bobbee3dTuto.png")

@Component({
    components: {
        // PartitionTag,
        RuleTable,
    },
})
export class PartitionTags extends Vue {
    newPartitionTagName: string = "";

    dialogCreatePartitionTag: boolean = false;

    dialogDisconnectPartitionTag: boolean = false;

    dialogEditPartitionTag: boolean = false;

    newPartitionTag: any = {
        id: "",
        name: "",
    };

    actions: any = {
        action: new DialogAction(),
    };

    selectedPartitionTag: any = null;

    logs: any = [];

    search = "";

    primaryLogs = documentLogs.map((l) => ({ value: l }));

    accessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
    };

    defaultAccessRightPartition = {
        id: "",
        key: "AccessRight",
        type: "AccessRight",
        name: "",
        tags: [],
    };

    currentTag: any = null;

    // showTagDialog: boolean = false;
    // tagLoading: boolean = false;

    currentTagName: string = "";

    companyId: string = "";

    deleteDialog: boolean = false;

    deleteLoading: boolean = false;

    toDeleteTagId = "";

    tags = [];

    errorTag = false;

    isExistingTagName = "";

    delayedDragging = false;

    newTags = {};

    condition = "";

    isDragging = false;

    filterCompany = null;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirmId() {
        return this.currentUser?.company?.id ? this.currentUser.company.id : null;
    }

    get filterCompanyId() {
        return this.filterCompany?.key && this.filterCompany?.value
            ? this.filterCompany.value
            : null;
    }

    get sortedPartitionTags() {
        debugger;

        const partitionTags = this.partitionTags;
        let filteredPartitionTags = partitionTags;
        if (this.search) {
            filteredPartitionTags = filteredPartitionTags
                .slice(1)
                .filter((x: { name: string }) =>
                    x.name.toLowerCase().includes(this.search.toLowerCase()),
                )
                .filter((x) => x.parent === null);
        }
        return filteredPartitionTags
            .slice(1)
            .filter((x) => x.parent === null)
            .sort((a: any, b: any) => a.name.localeCompare(b.name))
            .sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });
        companies.unshift({ value: "", key: "Toutes mes règles" });

        return companies;
    }

    initialize() {
        this.search = "";
    }

    beforeMount() {
        this.selectedPartitionTag = null;

        this.initialize();
    }

    refreshPartitionTags() {
        this.$apollo.queries.partitionTags.refetch();
        this.dialogCreatePartitionTag = false;
        this.dialogEditPartitionTag = false;
        this.dialogDisconnectPartitionTag = false;
    }

    // clearPartitionTag() {
    //     this.selectedPartitionTag = {
    //         id: "",
    //         name: "",
    //         clientCompanies: [],
    //         users: []
    //     }
    // }

    @Apollo({
        query() {
            return this.filterCompanyId ? PARTITION_TAGS_SCOPING : PARTITION_TAGS_ACCOUNTING_FIRM;
        },
        variables() {
            return {
                companyId: this.filterCompanyId ? this.filterCompanyId : this.accountingFirmId,
                // companyId: this.accountingFirmId,
                // condition: this.condition
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.accountingFirmId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    let accessRightPartition = _.cloneDeep(this.defaultAccessRightPartition);
                    const partitionTags = [];

                    // Check if tags exist in the data for PARTITION_TAGS_COMPANY
                    const tags =
                        data.tags && data.tags.length
                            ? data.tags.map((tag, index) => ({
                                  ...tag,
                                  order: index + 1,
                                  fixed: false,
                              }))
                            : [];

                    for (const pt of data.partitionTags
                        ? data.partitionTags
                        : data.partitionTagsScoping
                          ? data.partitionTagsScoping
                          : []) {
                        pt.key = pt.id;
                        if (pt.type !== "AccessRight") {
                            partitionTags.push(pt);
                        } else {
                            if (accessRightPartition.id) {
                                debugger;
                            }
                            accessRightPartition = pt;
                        }
                    }
                    this.initLogs();

                    for (const partition of partitionTags) {
                        let index = 1;
                        for (const tag of partition.tags) {
                            tag.order = index;
                            tag.fixed = false;
                            index++;
                        }
                        if (!partition.rules) {
                            partition.rules = {};
                        }
                        if (!partition.rules.rootAccountableAccounts) {
                            partition.rules.rootAccountableAccounts = [];
                        }
                    }

                    const withoutIdPartitionTag = {
                        id: "WithoutId",
                        key: "WithoutId",
                        name: "Non classé",
                        tags: [],
                    };
                    partitionTags.unshift(withoutIdPartitionTag);

                    // Handle tags for PARTITION_TAGS_COMPANY
                    if (tags.length) {
                        for (const tag of tags) {
                            if (tag.primaryLog) {
                                let logPartition = this.logs.find(
                                    (l) => l.primaryLog === tag.primaryLog,
                                );
                                if (!logPartition) {
                                    logPartition = {
                                        id: "",
                                        primaryLog: tag.primaryLog,
                                        key: tag.primaryLog,
                                        name: this.$t("document.type." + tag.primaryLog),
                                        tags: [],
                                    };
                                    this.logs.push(logPartition);
                                }
                                logPartition.tags.push(tag);
                            } else if (!tag.partitionTag) {
                                withoutIdPartitionTag.tags.push(tag);
                            }
                        }
                    }

                    const newTags = {};
                    partitionTags.forEach((partition) => {
                        newTags[partition.key] = "";
                    });
                    this.logs.forEach((partition) => {
                        newTags[partition.key] = "";
                    });
                    newTags[accessRightPartition.key] = "";

                    this.partitionTags = partitionTags;
                    this.accessRightPartition = accessRightPartition;
                    this.newTags = newTags;
                    this.tags = data.tags || [];
                } else {
                    this.partitionTags = [];
                    this.logs = [];
                    this.newTags = {};
                }
            }
        },
    })
    partitionTags = [];

    // @Apollo({
    //     query: USED_TAGS,
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             mode: "all",
    //         };
    //     },
    //     skip() {
    //         return !this.companyId;
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data?.usedTags?.tags) {
    //                 this.usedTags = data.usedTags.tags;
    //             }
    //         }
    //     },
    // })
    // usedTags = [];

    // async checkDeleteTag(tagId) {
    //     this.toDeleteTagId = tagId;
    //     if (this.tagDeletable(tagId)) {
    //         await this.deleteTag();
    //     } else {
    //         this.toDeleteTagId = tagId;
    //         this.deleteDialog = true;
    //         this.deleteLoading = false;
    //     }
    // }

    // async deleteTag() {
    //     if (this.toDeleteTagId) {
    //         this.deleteLoading = true;
    //         const deletedTag = await this.$apollo.mutate({
    //             mutation: DELETE_TAG,
    //             variables: {
    //                 tagId: this.toDeleteTagId,
    //             },
    //         });

    //         if (deletedTag.data.deleteTag) {
    //             this.tags = this.tags.filter((t) => t.id !== this.toDeleteTagId);
    //         }

    //         this.deleteLoading = false;
    //         this.deleteDialog = false;
    //         this.refresh();
    //     }
    //     // delete the tag in partitionTag
    //     // find the modified partition ID
    //     // find the deleted tag ID through partitionTags.find (the index is still in the list)
    //     // filter the list to delete the deleted tag
    //     // this.partitionTags[index].tags = this.partitionTags[index].tags.filter(t => t.id !== tagId);
    // }

    async updateTag(item, partitionId) {
        console.log("partitionId", partitionId);
        if (item?.added?.element) {
            await this.$apollo.mutate({
                mutation: UPDATE_TAG,
                variables: {
                    id: item.added.element.id,
                    partitionConnect:
                        partitionId === "WithoutId"
                            ? { disconnect: true }
                            : { connect: { id: partitionId } },
                },
            });
            this.refresh();
        } else if (item?.id) {
            console.log("partitionId", partitionId);
            await this.$apollo.mutate({
                mutation: UPDATE_TAG,
                variables: {
                    id: item.id,
                    partitionConnect:
                        partitionId === "WithoutId"
                            ? { disconnect: true }
                            : { connect: { id: partitionId } },
                },
            });
            this.refresh();
        }
    }

    // editTag(tag) {
    //     if (tag) {
    //         this.currentTag = JSON.parse(JSON.stringify(tag));
    //         const partitionTag = this.partitionTags.find((pt) =>
    //             pt.tags.find((t) => t?.id === this.currentTag.id),
    //         );
    //         if (partitionTag?.type === "Building") {
    //             return;
    //         }
    //         this.currentTag.partitionTag = partitionTag;
    //         if (this.currentTag.type === "TagDistribution") {
    //             this.currentTag.percentageTags = this.currentTag.partitionTag.tags.filter(
    //                 (t) => t.type !== "TagDistribution",
    //             );
    //             this.currentTag.percentages = new Array(this.currentTag.percentageTags.length).fill(
    //                 0.0,
    //             );
    //             for (let index = 0; index < tag.percentageTags.length; index++) {
    //                 const percentageTag = tag.percentageTags[index];
    //                 const foldedIndex = this.currentTag.percentageTags.findIndex(
    //                     (t) => t.id === percentageTag.id,
    //                 );
    //                 if (foldedIndex >= 0 && foldedIndex < this.currentTag.percentageTags.length) {
    //                     this.currentTag.percentages[foldedIndex] = tag.percentages[index] * 100;
    //                 }
    //             }
    //         }
    //         this.tagLoading = false;
    //         this.showTagDialog = true;
    //     }
    // }

    // async upsertTag() {
    //     if (this.currentTag.type === "TagDistribution") {
    //         if (!this.currentTag || !this.currentTag.partitionTag) {
    //             debugger;
    //             return true;
    //         }
    //         // this.tagLoading = true;
    //         let percentageTags;
    //         if (this.currentTag.percentageTags && this.currentTag.percentageTags.length) {
    //             percentageTags = this.currentTag.percentageTags
    //                 .filter((t, index) => this.currentTag.percentages[index] !== 0)
    //                 .map((t) => ({ id: t.id }));
    //         }
    //         let percentages;
    //         if (this.currentTag.percentages && this.currentTag.percentages.length) {
    //             percentages = this.currentTag.percentages
    //                 .filter((p) => p !== 0)
    //                 .map((p) => p * 0.01);
    //         }
    //         await this.$apollo.mutate({
    //             mutation: UPSERT_TAG_DISTRIBUTION,
    //             variables: {
    //                 id: this.currentTag.id,
    //                 type: this.currentTag.type,
    //                 name: this.currentTagName,
    //                 companyId: this.companyId,
    //                 partitionTagId: this.currentTag.partitionTag
    //                     ? this.currentTag.partitionTag.id
    //                     : undefined,
    //                 percentages,
    //                 percentageTags,
    //                 primaryLog: this.currentTag.primaryLog || undefined,
    //             },
    //         });
    //     } else if (this.currentTag.id) {
    //         await this.$apollo.mutate({
    //             mutation: UPDATE_TAG,
    //             variables: {
    //                 id: this.currentTag.id,
    //                 name: this.currentTagName,
    //             },
    //         });
    //     } else {
    //         console.error("TagManager - upsertTag currentTag.id is null");
    //         return;
    //     }
    //     this.refresh();
    //     this.tagLoading = false;
    //     this.showTagDialog = false;
    //     this.currentTag = null;
    // }

    // async createTag(partition) {
    //     const key = partition.key;
    //     if (!key) {
    //         debugger; // git-ignore
    //         return;
    //     }
    //     const partitionId = partition.id;
    //     if (!this.isExistingTag(key)) {
    //         // if (!partition.id) {
    //         //     if (partition.type === "AccessRight") {
    //         //         const accessRightPartition = await createPartitionTag(this, this.companyId, null,"Droit d'accès", partition.type)
    //         //         partitionId = accessRightPartition.id
    //         //         this.accessRightPartition.id = accessRightPartition.id
    //         //         this.accessRightPartition.key = accessRightPartition.id
    //         //     } else if (!partition.primaryLog) {
    //         //         debugger // git-ignore
    //         //         return
    //         //     }
    //         // }
    //         const result = await this.$apollo.mutate({
    //             mutation: CREATE_FREE_TAG,
    //             variables: {
    //                 name: this.newTags[key],
    //                 primaryLog: partition.primaryLog || undefined,
    //                 partitionConnect:
    //                     !partitionId || partitionId === "WithoutId"
    //                         ? undefined
    //                         : { connect: { id: partitionId } },
    //                 companyId: partition?.accountingFirm?.id
    //                     ? this.accountingFirmId
    //                     : this.companyId
    //                       ? this.companyId
    //                       : this.accountingFirmId
    //                         ? this.accountingFirmId
    //                         : null,
    //             },
    //         });
    //         const createdTag = result.data.createTag;
    //         const addNewPartitionTag = this.partitionTags.find((x) => x.key === key);
    //         if (addNewPartitionTag) {
    //             addNewPartitionTag.tags.push(createdTag);
    //         } else if (this.accessRightPartition?.key === key) {
    //             this.accessRightPartition.tags.push(createdTag);
    //         } else if (createdTag.primaryLog) {
    //             const log = this.logs.find((l) => l.primaryLog === createdTag.primaryLog);
    //             if (log) {
    //                 log.tags.push(createdTag);
    //             } else {
    //                 debugger; // git-ignores
    //             }
    //         }
    //     } else {
    //         this.errorTag = true;
    //         this.isExistingTagName = this.newTags[key];
    //     }
    //     this.newTags[key] = "";
    // }

    async deletePartitionTag(partitionTag: any) {
        if (partitionTag?.id) {
            const deletedPartition = await this.$apollo.mutate({
                mutation: DELETE_PARTITION,
                variables: {
                    id: partitionTag.id,
                },
            });

            if (deletedPartition.data.deletePartitionTag) {
                this.partitionTags = this.partitionTags.filter((pt) => pt.id !== partitionTag.id);
                this.refresh();
                this.selectedPartitionTag = null;
                this.dialogDisconnectPartitionTag = false;
            }
        }
    }

    editPartitionTag(partitionTag: any = null) {
        if (partitionTag && partitionTag?.id) {
            this.$router.push({
                name: "partitionstags-edition",
                params: {
                    id: partitionTag.id,
                },
            });
        } else {
            this.$router.push({
                name: "partitionstags-new",
            });
        }
    }

    displayClientCompanies(partitionTag) {
        if (partitionTag?.clientCompanies?.length) {
            if (partitionTag?.clientCompanies?.length <= 3) {
                return partitionTag.clientCompanies
                    .map((clientCompany: any) => clientCompany.name)
                    .join(", ");
            } else {
                let string = "";
                for (let i = 0; i < 3; i++) {
                    string += partitionTag.clientCompanies[i].name + (i < 2 ? ", " : " ");
                }
                string +=
                    "+ " + (partitionTag?.clientCompanies?.length - 3) + " dossier(s) affecté(s)";
                return string;
            }
        } else {
            return "";
        }
    }

    displayWorkspaceUsers(partitionTag) {
        if (partitionTag?.users?.length) {
            if (partitionTag?.users?.length <= 3) {
                return partitionTag.users
                    .map((user: any) => user.firstname + " " + user.lastname)
                    .join(", ");
            } else {
                let string = "";
                for (let i = 0; i < 3; i++) {
                    string +=
                        partitionTag.users[i].firstname +
                        " " +
                        partitionTag.users[i].lastname +
                        (i < 2 ? ", " : " ");
                }
                string += "+ " + (partitionTag?.users?.length - 3) + " utilisateur(s) affecté(s)";
                return string;
            }
        } else {
            return "";
        }
    }

    @Watch("filterCompanyId")
    filterCompanyIdWatch() {
        debugger;
        this.$apollo.queries.partitionTags.refetch();
    }

    @Watch("isDragging")
    isDraggingWatch() {
        if (this.isDragging) {
            this.delayedDragging = true;
            return;
        }
        this.$nextTick(() => {
            this.delayedDragging = false;
        });
    }

    isExistingTag(key) {
        if (this.newTags[key]) {
            const name = this.newTags[key].toLowerCase();
            const tags = this.partitionTags.flatMap((x) => x.tags);
            return !!tags.filter((x) => x.name.toLowerCase() === name).length;
        }
        return true;
    }

    initLogs() {
        this.logs = documentLogs.map((dl) => ({
            id: "",
            primaryLog: dl,
            key: dl,
            name: this.$t("document.type." + dl),
            tags: [],
        }));
    }

    // disabledDeleteTag(partitionTag) {
    //     if (partitionTag?.type === "Building") {
    //         return true;
    //     }
    //     return false;
    // }

    // tagDeletable(tagId) {
    //     return !this.usedTags.find((t) => t.id === tagId);
    // }

    refresh() {
        this.$apollo.queries.partitionTags.refetch();
    }

    get maxHeightRT() {
        return "calc(100vh - 150px)";
        const innHeight = window.innerHeight;
        const vhHeight = (150 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }
}

export default toNative(PartitionTags);
</script>

<style scoped lang="scss">
.error,
.warning {
    color: #fff;
}
</style>
